import GlobalPrototypes from '@/config/services/globalPrototypes.ts'

export function useDefaultRoute() {
  return {
    defaultRoute: GlobalPrototypes.defaultRoute,
    onboardingDefaultRoute: GlobalPrototypes.onboardingDefaultRoute,
  }
}
